import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  setDatePickerConfig(config) {
    config.containerClass = 'theme-dark-blue';
    config.showWeekNumbers = false;
  }
}
